module.exports = __webpack_public_path__ + "static/small-is-the-new-big-f027985eda91c94e99242013d49048b1.jpg";